import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import { ShipValidationResult, ShipValidationRule, ShipValidationRuleKey } from "../type";
import { buildValidationSuccessfulResult } from "../util";
import type GlobalStore from "@/store";
import ShopType from "@/enum/ShopType";
import { Modal } from "antd";

/**
 * 提示京东最大回传运动号
 */
export default async function validateJdMaxEwaybill(
    orders: OrderDTO[],
    rule: ShipValidationRule,
    globalStore: typeof GlobalStore,
): Promise<ShipValidationResult> {
    if (!rule[ShipValidationRuleKey.checkJdMaxEwaybill]) return buildValidationSuccessfulResult(orders);

    const showTip = orders.some((order) => {
        const shop = globalStore.shopMapping.get(order.shopId);
        return shop?.type === ShopType.JD && order.ewaybills?.length > 10;
    });

    if (showTip) {
        await new Promise((yes) => {
            Modal.info({
                title: "京东回传单号提醒",
                content: "注意！由于京东平台接口限制京东订单最多回传10个运单号到京东后台，超出的运单号无法回传",
                onOk() {
                    yes(null);
                },
            });
        });
    }

    return buildValidationSuccessfulResult(orders);
}
